import Vue from "@/utils/gloable"
import Vant from 'vant';
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import "@/assets/css/recess.css"
import "@/assets/js/script.js"

Vue.config.productionTip = false
Vue.use(Vant);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')